import request from '@/utils/request';

// 根据字典类型获取字典列表 type
export function getDictsType(options) {
  return request({
    url: '/dicts/list?type=' + options,
    method: 'get'
  });
}
// 添加广告
export function getAdvAdd(options) {
  return request({
    url: '/op/apps/banner/',
    method: 'post',
    data: options
  });
}
// 编辑广告 添加广告
export function getAdvEdit(options) {
  return request({
    url: '/op/apps/banner/' + options.id,
    method: 'post',
    data: options
  });
}

// 获取广告列表 feedbackType pageNum pageSize
export function getAdvInfos(options) {
  return request({
    url: '/op/apps/banner/pagelist',
    method: 'get',
    params: options
  });
}
// 批量修改广告状态
export function getAdvStatus(options) {
  return request({
    url: '/op/apps/banner/batch-status',
    method: 'post',
    data: options
  });
}
// 广告上移下移
export function modifySeq(options) {
  return request({
    url: '/op/advertisingmanages/modifySeq',
    method: 'post',
    data: options
  });
}

// 广告上移下移
export function uploadImg(options) {
  return request({
    url: '/op/advertisingmanages/upload',
    method: 'post',
    data: options
  });
}
// 发布
export function bannerPublish(options) {
  return request({
    url: `op/apps/banner/publish`,
    method: 'post',
    data: options
  });
}

